import { connect } from 'react-redux'
import { state_update } from '../actions'
import AiOptionButton from './AiOptionButton'
import ReactGA from 'react-ga';

const mapStateToProps = (state, ownProps) => ({
  active: ownProps.value === state[ownProps.attr] ? true: false,
  notext:ownProps.value==='no'?' ai-notext ':' ',
  select: ownProps.value === state[ownProps.attr] ? 'ai-text-select ai-select ai-select-'+state.currentSite :'ai-text-unselect',
  buttonselect: ownProps.value === state[ownProps.attr] ? 'ai-button-select':'ai-text-unselect',
  selectText: ownProps.value === state[ownProps.attr] ? 'ai-color-'+state.currentSite:'ai-text-unselect',
  horoscopeText: "HOROSCOPE SIGN" === ownProps.optionTitle ? 'ai-horoscope':'',
  show: state['hide_'+ownProps.attr+'-' + ownProps.value] !== true ? 'ai-show':'ai-hide',
  showReview: state.showReview,
  sku: state.sku,
  chainm: state.m,
  locket: state.locket,
  cur_ga_event: state.ga_event,
// np:(state['acat'] !== '2') || (state['acat'] === '2' && state.s !== '9000') || (state['acat'] === '2' && state['e1'] !=='' && state['e1'] !==undefined && state.s === '9000')?true:false,
  optionsName:ownProps.optionsName.substring(9),
  optionsCat:state.acat
})


 

const mapDispatchToProps = (dispatch, ownProps) => ({
      onClick: ( (state) => { 
        //console.log(state)
        
        if (state !== 'Selected')
        ReactGA.event({
        category: 'Selected',
        action:ownProps.options_all.replace(ownProps.attr,'['+ownProps.attr +']') 
    });
    //if ((cur_details.option_name==='am' && this.props.np)||(cur_details.option_name==='acharm' && this.props.acharm !== '-1' && this.props.s  === '9082' && this.props.acat ==='5' && this.props.np))

  //   if (['acat','acust'].includes(ownProps.attr))
     if (['acust'].includes(ownProps.attr))
        dispatch(state_update({attr:"add",value:''}));
      
      dispatch(state_update({attr:ownProps.attr,value:ownProps.value}));
      if (ownProps.showReview !== true)
        dispatch(state_update({attr:'showReview',value:true}));
   //   console.log('act',ownProps)
      if (ownProps.active_view !== false)
        dispatch(state_update({attr:'active_view',value:ownProps.active_view}))
      //  dispatch(state_update({attr:'active_view',value:2}))
      dispatch(state_update({attr:'ga_event',value:'Selected'}));
      }
    )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AiOptionButton)


// WEBPACK FOOTER //
// ./src/layout/AiOptionButtonWrap.js